/*
  Sass
 */
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './scss/app.scss';

/*
  JS
 */

import Vue from 'vue'
import App from './App.vue'


// Components
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

import BootstrapVue from 'bootstrap-vue';
import i18n from './i18n'
Vue.use(BootstrapVue);


// Sweetalert
import VueSweetalert2 from 'vue-sweetalert2';
const options = {
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674'
};
Vue.use(VueSweetalert2, options);

/*
    Recaptcha v3
 */
import { VueReCaptcha } from 'vue-recaptcha-v3';
Vue.use(VueReCaptcha, { siteKey: '6LcW7ZAUAAAAAJnYqN2BeSfgwE-kzpMp1C0ZSKrR' });

Vue.config.productionTip = false;
new Vue({
 i18n,
 render: h => h(App)
}).$mount('#app');
